function toNumberOrNull(value) {
  if (value == null || value === '') return null
  const numeric = Number(value)
  return Number.isFinite(numeric) ? numeric : null
}

function buildUserSearchText(user) {
  const candidate = user && typeof user === 'object' ? user : {}
  const searchParts = [
    candidate.name,
    candidate.full_name,
    candidate.first_name,
    candidate.second_name,
    candidate.email,
    candidate.user,
    candidate.username,
  ]
  return searchParts
    .map((value) => (value == null ? '' : String(value).toLowerCase().trim()))
    .filter((value) => value.length > 0)
    .join(' ')
}

export function mapPlanningWorkflowUserToSelectOption(user) {
  const userId = toNumberOrNull(user && user.id)
  const name = user && user.name ? String(user.name) : ''
  const fullName = user && user.full_name ? String(user.full_name) : ''
  const email = user && user.email ? String(user.email) : ''
  const username = user && (user.user || user.username) ? String(user.user || user.username) : ''
  const displayName = [name, fullName, email, username].filter((value, index, values) => value && values.indexOf(value) === index).join(' | ') || String(userId != null ? userId : '')
  return {
    value: userId != null ? userId : user && user.id,
    name: displayName,
    searchText: buildUserSearchText(user),
  }
}

export function buildUniqueWorkflowUserSelectOptions(users) {
  const list = Array.isArray(users) ? users : []
  const options = list
    .map((userRow) => mapPlanningWorkflowUserToSelectOption(userRow))
    .filter((option) => option && option.value != null)
  const uniqueByValue = new Map()
  options.forEach((option) => {
    if (uniqueByValue.has(option.value)) return
    uniqueByValue.set(option.value, option)
  })
  return [...uniqueByValue.values()]
}
